import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";

import PsContext from "../../../context/PsContext";

const TopSearchBar = (props) => {
  const context = useContext(PsContext);
  const [redirect, setRedirect] = useState(false);
  const [keyVal, setKeyVal] = useState(null);
  const [searchVal, seTSearchVal] = useState();

  useEffect(() => {
    checkUrl();
  }, []);

  useEffect(() => {
    if (redirect) {
      props.history.push(`/search/${keyVal}`);
      setRedirect(false);
    }
  }, [redirect]);

  const checkUrl = () => {
    const path = props.location.pathname;
    const pathArray = path.split("/");
    if (pathArray.length > 1 && pathArray[1] === "search") {
      document.getElementById("inp_top_search_keyword").value = pathArray[2];
    } else {
      document.getElementById("inp_top_search_keyword").value = "";
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    let inputValue = form.txtsearch.value;
    setKeyVal(inputValue);
    setRedirect(true);
    seTSearchVal("");
  };

  return (
    <div className="tf-search-sticky">
      <form className="tf-mini-search-frm" onSubmit={handleFormSubmit}>
        <fieldset className="text">
          <input
            type="text"
            className="custom-input"
            placeholder="Search"
            id="inp_top_search_keyword"
            name="txtsearch"
            value={searchVal}
            onChange={(e) => seTSearchVal(e.target.value)}
            required
            aria-required="true"
          />
        </fieldset>
        <button type="submit" className="">
          <i className="icon-search mb-10"></i>
        </button>
      </form>
    </div>
  );
};

export default withRouter(TopSearchBar);
